import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    'justify-content': 'center',
    padding: '0',
    margin: '0',
    listStyle: 'none',
  },
  item: {
    ':not(:last-child)&::after': {
      content: '"|"',
      display: 'inline-block',
      margin: '0 10px',
    },
  },
});

interface Props {
  withBranding?: boolean;
  isLawFirm?: boolean;
  onlyShowImpressum?: boolean;
  style?: React.CSSProperties;
}

const LAW_FIRM_PREFIX = '/ra';

const getPath = (path: string, isLawFirm?: boolean) => `${isLawFirm ? LAW_FIRM_PREFIX : ''}${path}`;

const makeUrl = (path: string, isLawFirm?: boolean): string => `https://www.mineko.de${getPath(path, isLawFirm)}`;

export const Footer: React.FC<Props> = ({ withBranding, isLawFirm, onlyShowImpressum, ...otherProps }: Props) => {
  const classes = useStyles();
  return (
    <ul className={classes.root} {...otherProps}>
      {withBranding && (
        <li className={classes.item}>
          powered by{' '}
          <a href={makeUrl('/', false)} target="_blank" rel="noopener noreferrer">
            Mineko
          </a>
        </li>
      )}

      <li className={classes.item}>
        <a href={makeUrl('/impressum/', isLawFirm)} target="_blank" rel="noopener noreferrer">
          Impressum
        </a>
      </li>
      {!onlyShowImpressum && (
        <>
          <li className={classes.item}>
            <a href={makeUrl('/agb/', isLawFirm)} target="_blank" rel="noopener noreferrer">
              AGB
            </a>
          </li>
          <li className={classes.item}>
            <a href={makeUrl('/datenschutz/', isLawFirm)} target="_blank" rel="noopener noreferrer">
              Datenschutz
            </a>
          </li>
        </>
      )}
    </ul>
  );
};
